export type SpinnerSize = 'sm' | 'md' | 'lg'

const sizeClasses: Record<SpinnerSize, string> = {
  sm: 'h-3.5 w-3.5 border-2',
  md: 'h-5 w-5 border-2',
  lg: 'h-8 w-8 border-[3px]'
}

export type SpinnerProps = {
  size?: SpinnerSize
  className?: string
  /** 覆盖边框配色；默认灰环 + 主题主色头 */
  borderClassName?: string
}

export function Spinner({
  size = 'md',
  className = '',
  borderClassName = 'border-[var(--color-line)] border-t-[var(--color-primary)]'
}: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label="加载中"
      // 动效降级统一 motion-safe 写法（11 §9.3）：reduced-motion 下不挂动画类，静态圆环（主色弧仍在），
      // role=status + aria-label 已承担加载语义
      className={`inline-block motion-safe:animate-spin rounded-[var(--radius-pill)] ${borderClassName} ${sizeClasses[size]} ${className}`.trim()}
    />
  )
}
